/**
 * You can modify this file
 *
 * @version 6
 *
 */
import { notification } from 'antd';
import Axios, {
  AxiosRequestConfig,
  AxiosError,
  AxiosResponse,
  AxiosInstance,
} from 'axios';
//@ts-ignore
import qs from 'qs';
import { getTokenFromPersist, logOut, storeToken } from '../token';

const baseConfig: AxiosRequestConfig = {
  // baseURL: "https://msg.damopet24.com/core", // <--- Add your base url
  // baseURL: 'http://localhost:5000', // <--- Add your base url
  baseURL: 'https://messenger.holding5040.ir',
  // baseURL: 'http://192.168.171.233:5000', // <--- Add your base url
  headers: {
    Accept: 'application/json',
    // "Access-Control-Allow-Origin": "*",
    'Content-Type': 'application/json-patch+json',
    // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
  // withCredentials: true,
  paramsSerializer: (param) =>
    qs.stringify(param, { indices: false }),
};

let axiosInstance: AxiosInstance;

function getAxiosInstance(security: Security): AxiosInstance {
  if (!axiosInstance) {
    axiosInstance = Axios.create(baseConfig);
    console.log(document.cookie);
    // Response interceptor
    axiosInstance.interceptors.response.use(
      (async (
        response: AxiosResponse
      ): Promise<SwaggerResponse<any>> => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        /**
         * Example on response manipulation
         *
         * @example
         *   const swaggerResponse: SwaggerResponse = {
         *     ...response,
         *   };
         *   return swaggerResponse;
         */
        // console.log(response.headers["set-cookie"], response.data);
        if (response.data.message) {
          notification.success({
            message: 'خوشبختانه!',
            description: response.data.message,
          });
        }

        return response.data;
      }) as any,
      (error: AxiosError) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response) {
          if (error?.response?.status === 401) {
            storeToken.dispatch(logOut());
          }

          return Promise.reject(
            new RequestError(
              error.response.data as string,
              error.response.status,
              error.response
            )
          );
        }
        //@ts-ignore
        if (typeof error.response?.data?.message === 'string') {
          //@ts-ignore
          //@ts-ignore
          new Promise.reject(
            notification.error({
              message: 'متاسفانه!',
              //@ts-ignore
              description: error.response?.data?.message,
            })
          );
        }
        //@ts-ignore
        Object.keys(error.response?.data.message).map((item) => {
          //@ts-ignore
          return item;
          //  error.response?.data.message[item].map((message) => {
          //   return notification.error({
          //     message: "متاسفانه!",
          //     description: message,
          //   });
          // });
        });

        // if (error.response) {
        //   return Promise.reject(
        //     new RequestError(
        //       error.response.data as string,
        //       error.response.status,
        //       error.response
        //     )
        //   );
        // }

        if (error.isAxiosError) {
          return Promise.reject(
            new RequestError('noInternetConnection')
          );
        }
        return Promise.reject(error);
      }
    );
  }

  // ًًRequest interceptor
  axiosInstance.interceptors.request.use(
    async (requestConfig) => {
      // Do something before request is sent
      /** Example on how to add authorization based on security */

      // console.log(requestConfig.headers)
      // if (security?.[0]) {
      requestConfig.headers.authorization = `Bearer ${getTokenFromPersist()}`;
      // }
      return requestConfig;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  return axiosInstance;
}

class RequestError extends Error {
  constructor(
    public message: string,
    public status?: number,
    public response?: AxiosResponse
  ) {
    super(message);
  }

  isApiException = true;

  static isRequestError(error: any): error is RequestError {
    return error.isApiException;
  }
}

export type Security = any[] | undefined;

// export interface SwaggerResponse<R> extends AxiosResponse<R> {}
export type SwaggerResponse<R> = R;

export { getAxiosInstance, RequestError };
